<template>
  <div>
    <v-tabs>
      <v-tab @change="changeTab('doctor')">Lekarze</v-tab>
      <v-tab @change="changeTab('patient')">Pacjenci</v-tab>
    </v-tabs>

    <v-card>
      <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="20"
      >
        <template v-slot:[`item.link`]="{ item }">
          <a v-if="item.url" :href="item.url" target="_blank">
            {{ item.link_title ? item.link_title : item.url }}
          </a>
          <span v-else>---</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axiosConf from "../../axios-conf";

export default {
  name: "Pushes",
  data: function (){
    return {
      headers: [
        { text: "Typ", value: "type" },
        { text: "Tytuł", value: "title" },
        { text: "Notyfikacja", value: "notification" },
        { text: "Link", value: "link" },
        { text: "Data wysłania", value: "create_date" }
      ],
      items: []
    };
  },
  mounted() {
    this.changeTab('doctor');
  },
  methods: {
    changeTab(tabName){
      this.items.splice(0, this.items.length);
      axiosConf.get(`${tabName}/mobile-push.json`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
          }
        })
        .then(response => {
          this.items = [...response.data.pushes];
        });
    }

  }
}
</script>

<style scoped>

</style>
